import { toastr } from 'react-redux-toastr-custom'
import makeConnect from '@utils/makeConnect';

export default function UseToast(resource) {

	const mapStateToProps = null;

	const mapDispatchToProps = dispatch => ({
		toast: toastr,
	})

	return makeConnect(mapStateToProps, mapDispatchToProps)

}



// WEBPACK FOOTER //
// ./src/connects/toast.js